export default {
    name: '新規入場遵守事項タイトル',
    sortno: '並び順'
};
